<template>
    <div class="flex flex-wrap">
        <Multiselect
            v-model="month"
            :options="monthList"
            :can-clear="false"
            :can-deselect="false"
            placeholder="月"
            class="select-base xs:w-[calc(50%-0.5rem)] max-w-[7rem] ml-0 mr-2 mb-2"
        />
        <Multiselect
            v-model="year"
            :options="yearList"
            placeholder="年"
            :can-clear="false"
            :can-deselect="false"
            class="select-base xs:w-[calc(50%-0.5rem)] max-w-[7rem] ml-0 mr-2 mb-2"
        />
    </div>
    <div class="error-msg -mt-2">
        {{ errorMessage }}
    </div>
</template>

<script>
import { ref, toRefs } from 'vue';
import Multiselect from '@vueform/multiselect';

export default {
    components: {
        Multiselect,
    },
    props: {
        errorMessage: {
            type: String,
            default: ''
        },
        data: {
            type: Object,
            required: true,
        }
    },
    setup(props) {
        const yearList = ref([]);
        const monthList = ref([]);
        const { month, year } = toRefs(props.data);

        const makeYearList = () => {
            const list = [];
            const fullYear = new Date().getFullYear();
            for (let i = 0; i < 10; i++) {
                const y = String(fullYear + i).substring(2, 4);
                list.push(y);
            }
            return list;
        };
        const makeMonthList = () => {
            const list = [];
            for (let i = 1; i <= 12; i++) {
                const m = String(i).padStart(2, '0');
                list.push(m);
            }
            return list;
        };
        yearList.value = makeYearList();
        monthList.value = makeMonthList();
        return {
            yearList,
            monthList,
            month,
            year
        };
    },
};
</script>
